import React, { useState } from "react";
import { Container, Navbar, Modal, Button, Nav } from "react-bootstrap";
import Logo from "../../../assets/Images/logo.png";
import WebService from "../../../Services/WebService";
import { toast } from "react-toastify";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ProfileDropdown from "../../Header/ProfileDropdown";
import { BsBuildings, BsCashStack, BsPersonVcard, BsJournalCheck, BsGrid1X2 } from "react-icons/bs";

const RmHeader = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const getNotificationToken = () => localStorage.getItem("fcm_device_token");

  const unregisterDevice = () => {
    WebService.addLoader("deleteBtnModal");
    return WebService.postAPI({
      action: `unregister-device`,
      body: {
        token: getNotificationToken(),
        push_type: "WEB_PUSH",
      },
      isShowError: false,
    })
      .then(() => {
        WebService.removeLoader("deleteBtnModal");
        WebService.logout();
      })
      .catch((error: any) => {
        WebService.removeLoader("deleteBtnModal");
        toast.error(error?.response?.data?.message);
        return error;
      });
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <header className="site-header shadow-sm" style={{ width: "100%", left: 0, zIndex: 1000, background: "#ffffff" }}>
        <Container fluid className="header-nav py-1">
          <Navbar expand="lg" className="position-relative w-100 d-flex justify-content-between align-items-center">
            <Navbar.Brand 
              className="font-bold d-flex align-items-center m-0 me-3" 
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/rm")}
            >
              <img
                src={Logo}
                width={125}
                alt="Prime Shark"
                style={{
                  filter: "drop-shadow(0px 3px 6px rgba(0,0,0,0.15))",
                  transition: "transform 0.3s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.03)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "none"}
              />
            </Navbar.Brand>

            <div className="bg-light px-3 py-1.5 rounded-pill shadow-xs border d-none d-xl-flex align-items-center me-3">
              <span className="badge bg-primary-subtle text-primary me-2 px-2 py-1 rounded-pill font-11 fw-bold">RM</span>
              <h6 className="mb-0 fw-bold" style={{ color: "#2c3e50", letterSpacing: "0.5px", fontSize: "13px" }}>
                Relation Manager Portal
              </h6>
            </div>

            <Nav className="me-auto d-none d-md-flex align-items-center gap-1">
              <Nav.Link 
                as={Link} 
                to="/rm" 
                className={`px-3 py-2 rounded-pill font-14 fw-semibold d-flex align-items-center gap-1.5 ${isActive("/rm") ? "bg-primary text-white" : "text-dark"}`}
              >
                <BsGrid1X2 size={15} /> Dashboard
              </Nav.Link>

              <Nav.Link 
                as={Link} 
                to="/rm/entrepreneurs" 
                className={`px-3 py-2 rounded-pill font-14 fw-semibold d-flex align-items-center gap-1.5 ${isActive("/rm/entrepreneurs") ? "bg-primary text-white" : "text-dark"}`}
              >
                <BsBuildings size={15} /> Entrepreneurs
              </Nav.Link>

              <Nav.Link 
                as={Link} 
                to="/rm/investors" 
                className={`px-3 py-2 rounded-pill font-14 fw-semibold d-flex align-items-center gap-1.5 ${isActive("/rm/investors") ? "bg-primary text-white" : "text-dark"}`}
              >
                <BsCashStack size={15} /> Investors
              </Nav.Link>

              <Nav.Link 
                as={Link} 
                to="/rm/mentors" 
                className={`px-3 py-2 rounded-pill font-14 fw-semibold d-flex align-items-center gap-1.5 ${isActive("/rm/mentors") ? "bg-primary text-white" : "text-dark"}`}
              >
                <BsPersonVcard size={15} /> Mentors
              </Nav.Link>

              <Nav.Link 
                as={Link} 
                to="/rm/interaction-logs" 
                className={`px-3 py-2 rounded-pill font-14 fw-semibold d-flex align-items-center gap-1.5 ${isActive("/rm/interaction-logs") ? "bg-primary text-white" : "text-dark"}`}
              >
                <BsJournalCheck size={15} /> Activity Logs
              </Nav.Link>
            </Nav>

            <div className="d-flex align-items-center ms-auto gap-3">
              <ProfileDropdown setShowLogout={setShow} />
            </div>
          </Navbar>
        </Container>

        <Modal
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={() => setShow(false)}
        >
          <Modal.Header closeButton className="border-bottom-0 pb-0">
            <h4 className="font-24">Logout?</h4>
          </Modal.Header>

          <Modal.Body className="pt-0">
            <div className="mb-4 text-center">
              <p className="mb-0">Are you sure you want to logout?</p>
            </div>
            <div className="text-center">
              <Button
                variant="secondary me-3 px-4"
                onClick={() => setShow(false)}
              >
                No
              </Button>
              <Button
                variant="danger px-4"
                id="deleteBtnModal"
                onClick={() => {
                  if (getNotificationToken()) {
                    unregisterDevice();
                  } else WebService.logout();
                }}
              >
                Yes
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
};

export default RmHeader;
